export default __webpack_public_path__ + "static/media/danta_dark_male.875d5c3d.png";